"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listen = void 0;
var env_1 = require("./env");
function hook(obj, fnName, cbHook) {
    if (!obj || !obj[fnName]) {
        return;
    }
    var original = obj[fnName];
    obj[fnName] = function () {
        cbHook.apply(null, arguments);
        return original.apply(obj, arguments);
    };
}
function onLoad(cb) {
    setTimeout(function () { return (0, env_1.getWindowIfTop)(function (window) { return cb(window.location.href); }); });
}
function onPushState(cb) {
    (0, env_1.getWindowIfTop)(function (_a) {
        var history = _a.history;
        return ['pushState', 'replaceState'].forEach(function (fnName) {
            hook(history, fnName, function (_, __, url) { return cb(url); });
        });
    });
}
function onPopState(cb) {
    (0, env_1.getWindowIfTop)(function (window) {
        return window.addEventListener('popstate', function () { return cb(window.location.href); });
    });
}
function listen(cb) {
    (0, env_1.getWindowIfTop)(function (window) {
        var fromUrl = window.document.referrer;
        [onLoad, onPushState, onPopState].forEach(function (event) {
            return event(function (toUrl) {
                cb(fromUrl, toUrl);
                fromUrl = toUrl;
            });
        });
    });
}
exports.listen = listen;
//# sourceMappingURL=navigator.js.map